<h3 trans>Buttons</h3>

<div class="material-panel" *ngIf="active$ | async as active">
  <h4 trans>Raised</h4>
  <div class="row">
    <div class="border" [class.active]="active.type === 'raised' && active.variant === 'square'">
      <button
        type="button"
        class="btn-square"
        color="accent"
        mat-raised-button
        (click)="changeBtnType('raised', 'square')"
        trans
      >
        Square
      </button>
    </div>
    <div class="border" [class.active]="active.type === 'raised' && active.variant === 'rounded'">
      <button
        type="button"
        color="accent"
        mat-raised-button
        (click)="changeBtnType('raised', 'rounded')"
        trans
      >
        Rounded
      </button>
    </div>
    <div class="border" [class.active]="active.type === 'raised' && active.variant === 'pill'">
      <button
        type="button"
        class="btn-pill"
        color="accent"
        mat-raised-button
        (click)="changeBtnType('raised', 'pill')"
        trans
      >
        Pill
      </button>
    </div>
  </div>

  <h4 trans>Flat</h4>
  <div class="row">
    <div class="border" [class.active]="active.type === 'flat' && active.variant === 'square'">
      <button
        type="button"
        class="btn-square"
        color="accent"
        mat-flat-button
        (click)="changeBtnType('flat', 'square')"
        trans
      >
        Square
      </button>
    </div>
    <div class="border" [class.active]="active.type === 'flat' && active.variant === 'rounded'">
      <button
        type="button"
        color="accent"
        mat-flat-button
        (click)="changeBtnType('flat', 'rounded')"
        trans
      >
        Rounded
      </button>
    </div>
    <div class="border" [class.active]="active.type === 'flat' && active.variant === 'pill'">
      <button
        type="button"
        class="btn-pill"
        color="accent"
        (click)="changeBtnType('flat', 'pill')"
        mat-flat-button
        trans
      >
        Pill
      </button>
    </div>
  </div>

  <h4 trans>Outline</h4>
  <div class="row">
    <div class="border" [class.active]="active.type === 'stroked' && active.variant === 'square'">
      <button
        type="button"
        class="btn-square"
        color="accent"
        mat-stroked-button
        (click)="changeBtnType('stroked', 'square')"
        trans
      >
        Square
      </button>
    </div>
    <div class="border" [class.active]="active.type === 'stroked' && active.variant === 'rounded'">
      <button
        type="button"
        color="accent"
        mat-stroked-button
        (click)="changeBtnType('stroked', 'rounded')"
        trans
      >
        Rounded
      </button>
    </div>
    <div class="border" [class.active]="active.type === 'stroked' && active.variant === 'pill'">
      <button
        type="button"
        class="btn-pill"
        color="accent"
        (click)="changeBtnType('stroked', 'pill')"
        mat-stroked-button
        trans
      >
        Pill
      </button>
    </div>
  </div>

  <h4 trans>Basic</h4>
  <div class="row">
    <div class="border" [class.active]="active.type === 'basic' && active.variant === 'square'">
      <button
        type="button"
        class="btn-square basic-btn"
        color="accent"
        mat-button
        (click)="changeBtnType('basic', 'square')"
        trans
      >
        Square
      </button>
    </div>
    <div class="border" [class.active]="active.type === 'basic' && active.variant === 'rounded'">
      <button
        type="button"
        color="accent"
        class="basic-btn"
        mat-button
        (click)="changeBtnType('basic', 'rounded')"
        trans
      >
        Rounded
      </button>
    </div>
    <div class="border" [class.active]="active.type === 'basic' && active.variant === 'pill'">
      <button
        type="button"
        class="btn-pill basic-btn"
        color="accent"
        mat-button
        (click)="changeBtnType('basic', 'pill')"
        trans
      >
        Pill
      </button>
    </div>
  </div>

  <color-picker-input [formControl]="colorControl" trans>Button Color</color-picker-input>
</div>
